import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58a9d365"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live_modal" }
const _hoisted_2 = { class: "modal_top" }
const _hoisted_3 = { class: "modal_top_left modal_align_center" }
const _hoisted_4 = { class: "modal_align_center" }
const _hoisted_5 = { class: "text_color" }
const _hoisted_6 = { class: "modal_align_center" }
const _hoisted_7 = {
  key: 0,
  class: "subAccount_modal_list",
  "infinite-scroll-distance": "20",
  "infinite-scroll-immediate": "false",
  style: {"overflow":"auto"}
}

import { ref } from 'vue';
import LiveItemSquare from '@/components/liveItem/LiveItemSquare.vue';
import { Modal, Input } from 'ant-design-vue';
import http from '@/api/conentCenter/communal';
import emitter from '@/utils/mitt';
import { emptyDataSec } from '@/assets';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'addLive',
  setup(__props, { expose }) {

const aModal = Modal;
const aInputSearch = Input.Search;
const route = useRoute();
const gatewayId = route.params.gatewayId;

const classifyList: any = ref([]);
const classify = ref(undefined);
const getFileList = () => {
  classifyList.value = [];
  http.get_sort_list({ params: { type: 3, portal_id: gatewayId } }).then((res) => {
    classifyList.value = [...res.data.data];
  });
};

const liveModal: any = ref(false);

const LiveList: any = ref([]);
let modalData = ref({
  page: 0,
  last_page: 0,
  total: 0,
  choice: false,
  keywords: '',
  select: false,
  selectAll: false,
});
const selectKeys = ref({});
const showModal = () => {
  modalData.value = {
    page: 0,
    last_page: 0,
    total: 0,
    choice: false,
    keywords: modalData.value.keywords,
    select: false,
    selectAll: false,
  };
  LiveList.value = [];
  selectKeys.value = [];
  getLive();
};
const getLive = () => {
  if (modalData.value.page <= modalData.value.last_page) {
    modalData.value.page++;
    // const data = {
    //   keywords: modalData.value.keywords,
    //   page: modalData.value.page,
    //   page_num: 10,
    //   file_class: classify.value,
    //   status_order: 1,
    //   file_class_status: 0,
    // };
    // http.getLiveList({ params: data }).then((res: any) => {
    //   const resData = res.data.data;
    //   modalData.value.last_page = resData.last_page;
    //   modalData.value.total = resData.total;
    //   LiveList.value.push(...resData.data);
    //   selectKeys.value = [];
    //   LiveList.value.map((res: any) => {
    //     selectKeys.value[res.id] = modalData.value.selectAll;
    //   });
    // });
    let params = {
      keywords: modalData.value.keywords,
      sort_id: classify.value,
      page: modalData.value.page,
      page_num: 10,
      portal_id: gatewayId,
    };
    http.get_portal_live_list({ params }).then((res) => {
      const resData = res.data.data;
      modalData.value.last_page = resData.last_page;
      modalData.value.total = resData.total;
      LiveList.value.push(...resData.data);
      selectKeys.value = [];
      LiveList.value.map((res: any) => {
        selectKeys.value[res.id] = modalData.value.selectAll;
      });
    });
  }
};

// 选中直播间
const selectLiveList: any = ref([]);
const selectLive = () => {
  selectLiveList.value = [];
  Object.keys(selectKeys.value).forEach((res) => {
    selectKeys.value[res] ? selectLiveList.value.push(res) : '';
  });
};
// 选择
const getSelect = () => {
  modalData.value.selectAll = false;
  modalData.value.choice = modalData.value.select;
  selectLive();
};
// 全选
const getSelectAll = () => {
  modalData.value.select = false;
  modalData.value.choice = modalData.value.selectAll;
  Object.keys(selectKeys.value).forEach((res) => {
    selectKeys.value[res] = modalData.value.selectAll;
  });
};
// 点击直播间
const getSelectKeys = (id: string) => {
  selectKeys.value[id] = !selectKeys.value[id];
  selectLive();
};
// 删除直播间
const deleteKey = ref<boolean>(false);
// const openDelModal = () => {
//   deleteKey.value = false;
// };
const deteleLive = () => {
  selectLiveList.value.length > 0 ? (deleteKey.value = true) : '';
};

const addLive = () => {
  liveModal.value = false;
  let live = LiveList.value.filter((res: any) => {
    return selectKeys.value[res.id];
  });
  emitter.emit('addlive', live);
};

expose({
  liveModal,
  showModal,
  getFileList,
});

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aModal), {
      visible: liveModal.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((liveModal).value = $event)),
      width: "80%",
      title: "添加直播",
      centered: "",
      onOk: addLive
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(aInputSearch), {
                placeholder: "搜索直播间标题",
                class: "mod_range_picker_search",
                value: _unref(modalData).keywords,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(modalData).keywords) = $event)),
                onSearch: _cache[1] || (_cache[1] = ($event: any) => (showModal()))
              }, null, 8, ["value"]),
              _createVNode(_component_a_select, {
                value: classify.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((classify).value = $event)),
                class: "modal_select",
                "show-search": "",
                placeholder: "请选择站内链接",
                onChange: showModal
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classifyList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" 直播间： "),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(modalData).total), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_checkbox, {
                checked: _unref(modalData).select,
                "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_unref(modalData).select) = $event)),
                onChange: getSelect,
                class: "modal_operation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                checked: _unref(modalData).selectAll,
                "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(modalData).selectAll) = $event)),
                onChange: getSelectAll,
                class: "modal_operation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全选")
                ]),
                _: 1
              }, 8, ["checked"])
            ])
          ]),
          (LiveList.value.length !== 0)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(LiveList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "modal_list",
                    key: item
                  }, [
                    _createVNode(LiveItemSquare, {
                      "data-source": item,
                      choice: _unref(modalData).choice,
                      selected: selectKeys.value[item.id],
                      onClick: ($event: any) => (getSelectKeys(item.id))
                    }, null, 8, ["data-source", "choice", "selected", "onClick"])
                  ]))
                }), 128))
              ])), [
                [_directive_infinite_scroll, getLive]
              ])
            : _createCommentVNode("", true),
          (LiveList.value.length == 0)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "empty_wrap",
                image: _unref(emptyDataSec),
                description: "页面暂无数据信息~"
              }, null, 8, ["image"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})